<mat-card appearance="outlined" class="se-block">
  <div class="measures-content">
    <global-annotations *ngIf="showGlobalMeasures" [annotations]="globalMeasures" [class.se-read-only]="readOnly">
    </global-annotations>
    <custom-measures *ngIf="showCustomMeasures" [measures]="customMeasures" [readOnly]="readOnly"
      (measureChange)="onManualMeasureChange($event)" (closeClicked)="onCloseCustomMeasures()">
    </custom-measures>
    <caliper-measures [measuresList]="caliperMeasures" *ngIf="showCaliperMeasures" [readOnly]="readOnly"
      [customMeasureButtons]="customMeasureButtons" (measuresRemove)="onCaliperMeasuresRemove($event)" (measuresRemoveAll)="onCaliperMeasuresRemoveAll()"
      (measuresSet)="onCaliperMeasuresSet($event)" class="caliper-measures">
    </caliper-measures>
  </div>
</mat-card>
